module.exports = __webpack_public_path__ + "img/JasonLuke.ed984269.jpg";